<div class="file-home">
  <div class="file-home__content">
    <div class="file-home__header">
      <div>
        <h1 class="page-title">Files</h1>
        <p class="page-subtitle">Manage and organize your uploaded files.</p>
      </div>
    </div>

    <app-table
      [data]="fileState.data()"
      [columns]="filesColumns"
      [config]="filesConfig"
      [pagination]="filesPagination"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onSearchChange($event)"
      (dateRangeChange)="onDateRangeChange($event)"></app-table>
  </div>
</div>
